/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useState } from 'react'
import { GButton } from 'components/basic-blocks'
import { useStores } from 'hooks'
import { RulesListProps } from './types'
import { Rules } from '../../../../../../../../services/user/rules'
import { toast } from 'react-toastify'
import { GNewToggle } from '../../../../../../../../components/basic-blocks/g-new-toggle/g-new-toggle'

export const RulesSettings = ({
	level,
	targetId,
	platform
}: RulesListProps) => {
	const { assetStore } = useStores()
	const { asset, adAccounts, campaigns } = assetStore

	const ad_account_id = level === 'ad-account' ? targetId : null
	const campaign_id = level === 'campaign' ? targetId : null

	const selectedAdAccount = ad_account_id
		? adAccounts.find((a) => a.id === ad_account_id)
		: adAccounts[0]
	const selectedCampaign = campaign_id
		? campaigns.find((a) => a.id === campaign_id)
		: campaigns[0]

	const [inheritSettings, setInheritSettings] = useState(true)

	useEffect(() => {
		if (level === 'ad-account') {
			setInheritSettings(
				selectedAdAccount?.rules_settings?.inherit !== undefined
					? selectedAdAccount?.rules_settings?.inherit
					: true
			)
		}
		if (level === 'campaign') {
			setInheritSettings(
				selectedCampaign?.rules_settings?.inherit !== undefined
					? selectedCampaign?.rules_settings?.inherit
					: true
			)
		}
	}, [level, selectedAdAccount, selectedCampaign])

	const onSaveChange = () => {
		if (level === 'ad-account' && ad_account_id) {
			try {
				Rules.adAccountInheritSettings({
					accountId: asset?.account_id,
					ad_account_id,
					inherit: inheritSettings
				}).then(() => toast.success('Settings updated successfully'))
			} catch (e) {
				toast.error('Failed to toggle status')
				return
			}
		}
		if (level === 'campaign' && campaign_id) {
			try {
				Rules.campaignInheritSettings({
					accountId: asset?.account_id,
					ad_account_id: selectedCampaign?.ad_account_id,
					campaign_id,
					inherit: inheritSettings,
					platform
				}).then(() => toast.success('Settings updated successfully'))
			} catch (e) {
				toast.error('Failed to toggle status')
				return
			}
		}
	}

	return (
		<div>
			<div>
				<header className="pb-4 border-b border-b-gray-100 mb-6">
					<div className="flex align-middle justify-between">
						<strong className="font-medium text-t-default text-xl">
							Custom rules settings
						</strong>
						<GButton
							label="Save changes"
							variant="contained"
							color="yellow"
							labelClassName="font-medium text-base"
							className="h-[30px] rounded-full disabled:!shadow-none !shadow-s-yellow"
							onClick={() => {
								onSaveChange()
							}}
						/>
					</div>
					<span className="text-t-checkbox-unactive font-md leading-5">
						Inherit custom rules settings
					</span>
				</header>
			</div>
			<div className="flex flex-row items-start">
				<GNewToggle
					checked={inheritSettings}
					onChange={() => setInheritSettings(!inheritSettings)}
					activeColor="success"
				/>
				<div className="flex flex-col ml-6 w-full">
					<strong className="mb-2  max-w-[250px] truncate">
						Inherit custom rule settings
					</strong>
				</div>
			</div>
		</div>
	)
}
